export const FETCH_DEPT = 'views/users/FETCH_DEPT'

